const tournament = "the_open_2026"
const leaderboard = "leaderboard_the_open_2026"
const title = "The Open"
const fechaLim = '16 de julio'
const year = '2026'
const coursePar = 70
const version = '1.5.8'
export { tournament, leaderboard, title, fechaLim, year, coursePar, version }